import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));
  const location = useLocation();
  // if (!loginDetails || !loginDetails.isAdmin) {
  // if (!loginDetails && (!loginDetails.isAdmin || loginDetails.roleId == 3)) {
  if (!loginDetails || !loginDetails.isAdmin) {
    // Redirect to home if the user is not logged in or not an admin
    return <Navigate to="/" replace />;
  }

  if(location?.pathname && !location?.pathname.includes("dashboard/chat") && loginDetails?.roleId == 2)
    return <Navigate to="/dashboard/chat" replace />;

  return children;
};

export default ProtectedRoute;
